import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearch } from '@tanstack/react-router';
import { useAuthStore } from '../../lib';
import { Button, Input, Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter, useToast } from '@lancar-pos/ui';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn, isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const search = useSearch({ from: '/app/login' });
  const toast = useToast();

  const redirect = (search as any)?.redirect || '/app';

  useEffect(() => {
    if (isAuthenticated) {
      navigate({ to: redirect, replace: true });
    }
  }, [isAuthenticated, navigate, redirect]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await signIn(email, password);
    
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      toast.success('Berhasil masuk', 'Selamat datang kembali!');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 bg-primary-600 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-xl">LP</span>
            </div>
          </div>
          <CardTitle className="text-center">Masuk ke LancarPOS</CardTitle>
          <CardDescription className="text-center">
            Masukkan email dan kata sandi untuk masuk
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
                {error}
              </div>
            )}
            <Input
              label="Email"
              type="email"
              placeholder="email@contoh.com"
              value={email}
              onChange={setEmail}
              required
            />
            <Input
              label="Kata Sandi"
              type="password"
              placeholder="Masukkan kata sandi"
              value={password}
              onChange={setPassword}
              required
            />
            <div className="text-right">
              <Link to="/app/forgot-password" className="text-sm text-primary-600 hover:underline">
                Lupa kata sandi?
              </Link>
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-4">
            <Button type="submit" fullWidth loading={loading}>
              Masuk
            </Button>
            <p className="text-sm text-center text-gray-600">
              Belum punya akun?{' '}
              <Link to="/app/register" className="text-primary-600 hover:underline font-medium">
                Daftar sekarang
              </Link>
            </p>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
